import { render } from "./product-group-detail.vue?vue&type=template&id=d62b321c"
import script from "./product-group-detail.vue?vue&type=script&lang=js"
export * from "./product-group-detail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__